// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 884 ? "admin" : chunkId) + "." + {"418":"8bf65fa1","668":"ed6fa068","740":"74c50283","833":"bd3ec0ff","865":"63e732c2","884":"81fc8c2d","906":"17c80352"}[chunkId] + ".js";
};